import React from 'react';

export default () => <h1> </h1>;
